import React from 'react'
import './work.css'
import Works from './Works'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react';

function Work() {

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      document.querySelector(".portfolio__section__title").style.transform = " translateX(0)"
      document.querySelector(".portfolio__section__title").style.opacity = 1
      document.querySelector(".portfolio__section__subtitle").style.transform = " translateX(0)"
      document.querySelector(".portfolio__section__subtitle").style.opacity = 1
    } else {
      document.querySelector(".portfolio__section__title").style.transform = " translateX(-150px)"
      document.querySelector(".portfolio__section__title").style.opacity = 0
      document.querySelector(".portfolio__section__subtitle").style.transform = " translateX(150px)"
      document.querySelector(".portfolio__section__subtitle").style.opacity = 0
    }
  }, [inView])
  return (
    <section className="work section" id='portfolio'>
      <h2 ref={ref} className="section__title portfolio__section__title">Portfolio</h2>
      <span ref={ref} className="section__subtitle portfolio__section__subtitle">Most recent works</span>
      <Works />
    </section>
  )
}

export default Work